import { TableCell } from "@material-ui/core";
import React from "react";
import IconeTooltip from "../IconeTooltip";

const CelulaTooltip = ({ title, placement }) => {

	return (
		<TableCell padding={"none"}>
				<IconeTooltip title={title} placement={placement} />
		</TableCell>
	)
}

export default CelulaTooltip;
